"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Kontakty pro použití ve formulářích subjektu.
 */
var AREA_ZR = exports.AREA_ZR = "AREA_ZR";
var AREA_ARES = exports.AREA_ARES = "AREA_ARES";
var AREA_ZR_ARES = exports.AREA_ZR_ARES = "AREA_ZR_ARES";
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvc3ViamVrdC9TdWJqZWt0Rm9ybUNvbnN0LmpzeCJdLCJuYW1lcyI6WyJBUkVBX1pSIiwiQVJFQV9BUkVTIiwiQVJFQV9aUl9BUkVTIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBOzs7QUFHTyxJQUFNQSw0QkFBVSxTQUFoQjtBQUNBLElBQU1DLGdDQUFZLFdBQWxCO0FBQ0EsSUFBTUMsc0NBQWUsY0FBckIiLCJmaWxlIjoiU3ViamVrdEZvcm1Db25zdC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogS29udGFrdHkgcHJvIHBvdcW+aXTDrSB2ZSBmb3JtdWzDocWZw61jaCBzdWJqZWt0dS5cbiAqL1xuZXhwb3J0IGNvbnN0IEFSRUFfWlIgPSBcIkFSRUFfWlJcIjtcbmV4cG9ydCBjb25zdCBBUkVBX0FSRVMgPSBcIkFSRUFfQVJFU1wiO1xuZXhwb3J0IGNvbnN0IEFSRUFfWlJfQVJFUyA9IFwiQVJFQV9aUl9BUkVTXCI7XG4iXX0=